// src/config/axiosInstance.ts
import axios from 'axios';
import urls from "../configmap/config.json";
import  store from '../redux/store'

const baseURL = urls.apiUrl;

const axiosInstance = axios.create({
  baseURL,  // Set the base URL dynamically using the domainNameResolver
  headers: {
    'Content-Type': 'application/json', // Default content type for JSON API calls
  },
});

// Axios request interceptor to add the access token to the headers
axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = store.getState().auth.accessToken;
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);




export default axiosInstance;
